import React from 'react'

import type {
  OrderFormItem,
  Message,
  OrderForm,
} from '../../../../../../core/requests/checkout'
import { useDrawer } from '../../../../../../ui/components'
import { getCartItemReactKey } from '../../../../utils'
import { EditCartItemDrawer } from '../EditCartItemDrawer/EditCartItemDrawer'
import { CartItemSkeleton } from './CartItemSkeleton'
import { CheckoutRoute } from '../../../../constants'
import { CheckoutProductListItem } from '../../../../components'

const checkItemIsLoading = (item: Partial<OrderFormItem>) => {
  return !item.uniqueId
}

export type CartItemProps = {
  item: Partial<OrderFormItem>
  itemIndex: number
  messages: Message[]
  currencyCode: string
  editionDisabled?: boolean
  updateCartItem: (
    itemId: string,
    itemIndex: number,
    simulationQuantity: number,
    sellerId: string,
    inHands?: boolean
  ) => Promise<OrderForm>
  removeCartItem: (
    itemId: string,
    itemIndex: number,
    sellerId: string
  ) => Promise<OrderForm>
}

export const CartItem = ({
  item,
  itemIndex,
  messages,
  currencyCode,
  editionDisabled,
  updateCartItem,
  removeCartItem,
}: CartItemProps) => {
  const editItemDrawer = useDrawer({
    route: `${CheckoutRoute.CartEditItem}/${getCartItemReactKey(
      item.id ?? '',
      itemIndex
    )}`,
  })

  const handleEditCartItemClick = () => {
    editItemDrawer.open()
  }

  const handleEditCartItemDrawerClose = () => {
    editItemDrawer.close()
  }

  if (checkItemIsLoading(item)) {
    return (
      <CartItemSkeleton item={{ imageUrl: item.imageUrl, name: item.name }} />
    )
  }

  return (
    <>
      <CheckoutProductListItem
        item={item as OrderFormItem}
        currencyCode={currencyCode}
        onEdit={handleEditCartItemClick}
        data-testid="cart-item"
      />
      <EditCartItemDrawer
        isOpen={editItemDrawer.isOpen}
        currencyCode={currencyCode}
        messages={messages}
        onClose={handleEditCartItemDrawerClose}
        item={item as OrderFormItem}
        itemIndex={itemIndex}
        removeCartItem={removeCartItem}
        updateCartItem={updateCartItem}
        editionDisabled={editionDisabled}
      />
    </>
  )
}
